// extracted by mini-css-extract-plugin
export default {"LogoYear":"LogoYear_LogoYear__IZzzo"};